// extracted by mini-css-extract-plugin
module.exports = {"overflow":"styles-module--overflow--2fowl","container":"styles-module--container--1HdVh","nav":"styles-module--nav--2XDbw"};